import * as React from 'react';
import { UIText1 } from '@cian/ui-kit/typography';
import { INFRASTRUCTURE_MAP_ICON_MAP } from '../../../../constants/infrastructure';
import { IInfrastructureType } from '../../../../types/newbuilding/infrastructureTypes';
import { VerticalScrollable } from '../../../VerticalScrollable';
import * as styles from './styles.css';

export interface IInfrastructureMapTypesProps {
  currentTypes: string[];
  onTypesChange: (types: string[]) => void;
  types: IInfrastructureType[];
}

export const InfrastructureMapTypes: React.FC<IInfrastructureMapTypesProps> = ({
  types,
  currentTypes,
  onTypesChange,
}) => {
  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const type = event.currentTarget.getAttribute('data-type') as string;
      onTypesChange(['main', type]);
    },
    [onTypesChange],
  );

  return (
    <div className={styles['list']}>
      <VerticalScrollable horizontalAlign={true}>
        {types.map(({ title, type }) => {
          const checked = currentTypes.includes(type);
          const Icon = INFRASTRUCTURE_MAP_ICON_MAP.get(type);

          if (!Icon) {
            return null;
          }

          return (
            <React.Fragment key={type}>
              <input
                type="radio"
                name={'infrastructureMapTypes'}
                checked={checked}
                onChange={handleChange}
                className={styles['input']}
                id={`infrastructure-map_${type}`}
                data-type={type}
              />
              <label aria-label={title} htmlFor={`infrastructure-map_${type}`} className={styles['label']}>
                <span className={styles['icon']}>
                  <Icon color={'gray_icons_100'} />
                </span>
                <UIText1>{title}</UIText1>
              </label>
            </React.Fragment>
          );
        })}
      </VerticalScrollable>
    </div>
  );
};
